import { Typography } from '@/components/common';
import clsx from 'clsx';
import React from 'react';
import { Quote } from './Quote';

interface Props {
	name: string;
	description: string;
	className?: string;
}

export const CardTestimonial: React.FC<Props> = ({
	name,
	description,
	className,
}) => {
	return (
		<div
			className={clsx(
				'bg-white pt-[60px] pb-10 px-8 relative rounded-[32px] w-[320px] h-[317px]',
				className
			)}
		>
			<div className="absolute -top-10 z-50">
				<Quote />
			</div>
			<div className="w-full space-y-6">
				<Typography type="regular-16" className="text-gray-35">
					{description}
				</Typography>
				<Typography type="semibold-18" className="text-[#0D0616]">
					{name}
				</Typography>
			</div>
		</div>
	);
};
